'use strict'

export default {
  async checkCurrentUser () {
    return await axios.get(`/api/user/me`)
  },
  login (data, cb, errorCb) {
    axios.post(`/login`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  logout (cb, errorCb) {
    axios.delete(`/logout`)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  register (data, cb, errorCb) {
    axios.post(`/register`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  registerResendSms (data, cb, errorCb) {
    axios.post(`/register/resend-sms`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  registerVerify (mobile, data, cb, errorCb) {
    axios.post(`/register/verify/${mobile}`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  registerUser (mobile, data, cb, errorCb) {
    axios.post(`/register/user/${mobile}`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  recovery (data, cb, errorCb) {
    axios.post(`/recovery`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  recoveryResendSms (data, cb, errorCb) {
    axios.post(`/recovery/resend-sms`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  recoveryVerify (mobile, data, cb, errorCb) {
    axios.post(`/recovery/verify/${mobile}`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
  recoveryUser (mobile, data, cb, errorCb) {
    axios.post(`/recovery/user/${mobile}`, data)
      .then(response => cb(response))
      .catch(err => {
        if (typeof errorCb === 'function') {
          errorCb(err)
        }
      })
  },
}
